import { createActionGroup, props } from '@ngrx/store';

import { ProjectTemplate } from '@core/api';

export const configApiActions = createActionGroup({
  source: 'Config/API',
  events: {
    'Add Project Templates': props<{ templates: ProjectTemplate[] }>(),
  },
});
